<span
  class="custom-tooltip"
  [matTooltip]="text"
  [matTooltipPosition]="position"
  [matTooltipDisabled]="!text">
  <ng-content></ng-content>
</span>

